import { useState } from "react";
import { RequestStatus } from "../../common";
import { reNameMaterial } from "@/services/createSpace/material";
import { Message } from "@arco-design/web-react";
import { portfolioRename } from "@/services/createSpace/portfolio";

interface IUseRenameReturn<T> {
  loading: RequestStatus;
  handleRenameRequest: (name: string, id: string) => Promise<T[] | null>;
  handlePortfolioRenameRequest: (
    name: string,
    id: string,
  ) => Promise<T[] | null>;
}

const useRename = <
  T extends { id: string; name: string },
>(): IUseRenameReturn<T> => {
  const [loading, setLoading] = useState<RequestStatus>(
    RequestStatus.NOTREQUESTED,
  );

  const handleRenameRequest = async (name: string, id: string) => {
    try {
      setLoading(RequestStatus.LOADING);
      await reNameMaterial(name, id);
      setLoading(RequestStatus.SUCCESS);
      Message.success("更新名称成功!");
    } catch (e) {
      setLoading(RequestStatus.FAILED);
      Message.error(e);
      return null;
    }
  };

  const handlePortfolioRenameRequest = async (name: string, id: string) => {
    try {
      setLoading(RequestStatus.LOADING);
      await portfolioRename(id as any, name);
      setLoading(RequestStatus.SUCCESS);
      Message.success("更新名称成功!");
    } catch (e) {
      setLoading(RequestStatus.FAILED);
      Message.error(e);
      return null;
    }
  };

  return {
    loading,
    handleRenameRequest,
    handlePortfolioRenameRequest,
  };
};

export default useRename;
